import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const BalancesPage = lazyWithRetry(() => import('../pages/BalancesPage.tsx'));

const balancesNode = {
  component: BalancesPage,
} satisfies ComponentPage;

const financeRoutes: ComponentOrMapping = {
  erp: {
    finance: {
      balances: balancesNode,
    },
  },
};

export default financeRoutes;
